/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { RecordData } from "./RecordData";
import { RecordBase } from "./RecordBase";
export const Record_ = core.serialization
    .object({
    values: RecordData,
})
    .extend(RecordBase);
